// Path: src\Components\Subscription\SubscriptionpackList.jsx

import React, { useState } from 'react';
import BaseHome from "../Home/BaseHome"
import PremiumTextLogo from "../Common/PremiumTextLogo";
import Button from "../CommonFields/Button";
import { Tabs, Tab } from '@mui/material';
import RenewBox from "../Home/RenewBox";
// import { checkDobNstateConditions } from "../Common";
// import pack1img from "../../subscription/Layer_x5F_1"
import packimg1 from "../../assets/images/subscription/Layer_x5F_1.png"
import packimg2 from "../../assets/images/subscription/OBJECTS (1).png"
import packimg3 from "../../assets/images/subscription/Layer_1 (4).png"
import packimg4 from "../../assets/images/subscription/Layer_1 (5).png"
import packimg5 from "../../assets/images/subscription/Layer_1 (6).png"
import packimg6 from "../../assets/images/subscription/Layer_1 (7).png"
import packimg7 from "../../assets/images/subscription/Layer_1 (8).png"
import coin from "../../assets/images/subscription/coin.png"
import { useEffect } from 'react';
import { toastError, toastSuccess } from "../../Utilities/toast";
import { getSubscriptionList, payUHashSubscription, getUserSubscriptionDetails, createPayPayment } from "../../api/subscription.api";
import SubscriptionPopup from './SubscriptionPopup';
import { useProfileDataContext } from '../ProfileContext/ProfileContext';
import PayUForm from '../PayU/PayUForm';

import { useNavigate } from 'react-router-dom';
import ListLoader from '../Common/ListLoader';
import { base_apis } from '../../config/url';
import { easeBuzzHash, easeBuzzPaymentStatus } from '../../api/auth.api';
import { toast } from 'react-toastify';
const Subscription = ({ isOpen, onClose, title, children }) => {
  const navigate = useNavigate();
  // const [loading, setLoading] = useState(true);
  const [selectedTab, setSelectedTab] = useState(null);
  const [tabs, setTabs] = useState([]);
  const [benefits, setBenefits] = useState(null);
  const [packs, setPacks] = useState(null);
  const [subscriptionList, setSubscriptionList] = useState(null);
  const [amount, setAmount] = useState(0);
  const [symbol, setSymbol] = useState("₹");
  const [paymentId, setPaymentId] = useState(null);
  const [active, setActive] = useState(null);
  const [payUData, setPayUData] = useState(null)
  const [showPayuForm, setShowPayuForm] = useState(false)

  const [isSubscriptionPopup, setIsSubscriptionPopup] = useState(false)
  const [subscriptionItem, setSubscriptionItem] = useState({});
  const { fetchAccountProfile } = useProfileDataContext();
  const [value, setValue] = useState(0);
  const [isSubscription, setIsSubscription] = useState(false);
  const [isLoding, setIsLoading] = useState(true);
  const [userData, setUserData] = useState(null);
  const [userSubscriptionDetails, setUserSubscriptionDetails] = useState(null);
  const [email, setEmailIdForPayment] = useState(null);

  useEffect(() => {
    let userProfileFromLocal = JSON?.parse(localStorage?.getItem("profile"))
    setEmailIdForPayment(userProfileFromLocal?.email)
  }, [])
  useEffect(()=>{
    console.log("tabs",tabs)
    console.log("selectedTab",selectedTab)
  },[selectedTab])
  const handleChange = (event, newValue) => {
    // console.log("newValue", newValue)
    setSelectedTab(newValue);
    let selectedPack = packs.filter((e) => e._id === newValue)
    setSubscriptionItem(selectedPack?.[0])
    setActive(selectedPack?.[0].packName||'');
    setSymbol(symbol);
    setAmount(selectedPack?.[0]?.amount||0);
    setPaymentId(selectedPack?.[0]._id);
  };
  const getBenefitsImg = (data) => {
    return data ? `${base_apis?.imageUrl}${data}` : packimg1;

  };
  const getsavedCurrencyImg = (data) => {
    return data ? `${base_apis?.imageUrl}${data}` : packimg1;

  };
  
  // Fetch SubscriptionTypes
  useEffect(() => {
    let country = JSON.parse(localStorage.getItem('countryId'))
    if (country) {
      fetchSubscriptionList();
      fetchUserSubscriptionDetails();
    }
  }, [])
  const fetchSubscriptionList = async () => {
    setIsLoading(true)
    try {
      let country = JSON.parse(localStorage.getItem('countryId'))
      let payload = {
        country: country
      }
      const res = await getSubscriptionList(payload);
      if (res?.success && res?.data?.[0]) {
        setSubscriptionList(res?.data?.[0])
        setPacks(res?.data?.[0].packs)
        setBenefits(res?.data?.[0].benefits)
        setSelectedTab(res?.data?.[0].packs?.[0]?._id)
        setSymbol(res?.data?.[0]?.currencyID?.symbol)
        setSubscriptionItem(res?.data?.[0].packs?.[0])
        setActive(res?.data?.[0].packs?.[0].packName || '');
        setAmount(res?.data?.[0].packs?.[0]?.amount || 0);
        setPaymentId(res?.data?.[0].packs?.[0]._id);
        setIsLoading(false)
      }
      else {
        setSubscriptionList([])
      }
    } catch (error) {
      // console.log("fetchSubscriptionList",error)
      
    }
  };


  const fetchUserSubscriptionDetails = async () => {
    setIsLoading(true)
    try {
      let userDetails = JSON.parse(localStorage.getItem('profileLite'))
      const res = await getUserSubscriptionDetails(userDetails.user_id);
      if (res?.success && res?.data){
        setUserSubscriptionDetails(res?.data)
        setIsLoading(false)
      }
      else {
        setUserSubscriptionDetails(null)
      }
    } catch (error) {
      console.log("fetchUserSubscriptionDetails", error)
    }
  };


  useEffect(() => {
    if (packs && packs.length > 0) {
      let tempPacksList = packs.map((e) => {
        return { label: e.packName, value: e._id, price: (`${e.amount} ${subscriptionList.currencyID.symbol}`) }
      })
      setTabs(tempPacksList)
    }
  }, [packs])

///xsolla transation
  const movePayment = async (userDetails, subscriptionItem) => {
    // setLoading(true);

    // let payload = {
    //   subscriptionId: paymentId,
    //   isMobile: true,
    // };

    // let data = await createXsollaSubscriptionTransaction(payload);
    // if (data?.success) {
    //   let transactionUniqueID = data?.data?.transactionUniqueID;
    //   let body = {
    //     transactionUniqueID: transactionUniqueID,
    //     subscriptionId: paymentId,
    //     isMobile: false,
    //   };
    //   localStorage.setItem("body", JSON.stringify(body));
    //   setToken(data?.data?.token);
    //   setLoading(false);
    //   let url = `https://secure.xsolla.com/paystation4/?token=${data?.data?.token}`;
    //   window.location.href = url;
    // } else {
    //   setLoading(false);
    // }
  }
///PayU transation
  const movePaymentWithPayU = async (userDetails, subscriptionItem) => {
    // console.log("**********throughpayupayment", amount, paymentId, active, subscriptionItem?.[0].amount)
    try {
      let payload = {
        key: process.env.REACT_APP_KEY,
        amount: amount,
        productId: paymentId,
        email: userDetails?.email || JSON.parse(localStorage.getItem('profile'))?.email,
        // phone: userDetails?.email || JSON.parse(localStorage.getItem('profile'))?.email,
        productInfo: process.env.REACT_APP_SUBSCRIPTION_PRODUCT,
        surl: process.env.REACT_APP_BASE_URL + "subscription/payment-status",
        furl: process.env.REACT_APP_BASE_URL + "subscription/payment-status",
        curl: process.env.REACT_APP_BASE_URL + "subscription/payment-status",
        userId: userDetails?._id,
        description: active,
        platform: "viwebapp"
      };
      // console.log(payload)
      let res = await payUHashSubscription(payload);
      // console.log("RESPONSE::",res)
      if (res?.success || true) {
        payload = { ...payload, hash: res?.hash, txnid: res?.transactionID  }
        await createPayPayment(payload)
        setPayUData(payload)
        setShowPayuForm(true)
        setTimeout(() => {
        }, 500)
        // setPayUData(payload)

      }
    } catch (error) {

    }
  }
  const handlerEaseBuzzForm = async (item, userDetails) => {
    console.log("handlerEaseBuzzForm", item, userDetails)
    // let verifiedEmail = localStorage.getItem('verifiedEmail')
    // console.log(">>>>>>>>>>>>handlerPayuForm:: subscription", item)
    // if ((liteProfile?.item?.isEmailVerified && liteProfile?.item?.isMobileVerified) || (selectedItem && selectedItem !== null && verifiedEmail)) {
      try {
        var easebuzzCheckout = new window.EasebuzzCheckout(
          process.env.REACT_APP_EASEBUZZ_API_KEY,
          process.env.REACT_APP_EASEBUZZ_API_MODE
        );
        let payload = {
          amount: item?.amount,
          productId: item?._id,
          email: userDetails?.email,
          phone: userDetails?.phone,
          productInfo: process.env.REACT_APP_SUBSCRIPTION_PRODUCT,
          userId: userDetails?._id,
          firstname: userDetails?.gamerjiName,
          packName: item?.packName,
          platform: "webportal"
        };
        console.log("payload", payload)
        let res = await easeBuzzHash(payload);
        console.log("success", res?.success, res?.data?.accessToken)
        // console.log("success", res?.success,)
        if (res?.success) {
          var options = {
            access_key: res?.data?.accessToken,
            onResponse: (response) => {
              let paymentStatus = "";
              let messageError = "";
              if (response?.status === "success") {
                paymentStatus = "SUCCESS";
                messageError = "";
                // toast.success("Your payment was successfully.");
              } else if (response?.status === "failure") {
                paymentStatus = "FAILED";
                messageError = "We couldn`t process your payment.";
                // toast.error("We couldn`t process your payment.");
              } else if (response?.status === "userCancelled") {
                paymentStatus = "USER_CANCELLED";
                messageError = "You have cancelled your payment process.";
                // toast.error("You have cancelled your payment process.");
              } else {
                paymentStatus = response?.status?.toUpperCase();
                messageError = "Oh no, your payment failed.";
                // toast.error("Oh no, your payment failed");
              }
              onPurchaseGems(response, paymentStatus, res.data, payload, messageError, res.data.transactionUniqueID);
            },
            theme: "#123456",
          };
          // console.log(easebuzzCheckout);
          easebuzzCheckout.initiatePayment(options);
        }
        else {
          const error = res?.response?.data?.data?.[0] || res?.error?.response?.data?.data?.[0];
          toast.error(error?.msg || "We couldn`t process your payment.");
        }
      } catch (error) {
        console.log("error", error)
      }
    // } else {
    //   setSelecetedItem(item)
    //   setEmailVerificationModal(true);
    // }
  }
  const onPurchaseGems = async (paymentRes, paymentStatus, data, values, messageError, transactionUniqueID) => {
    paymentRes = { ...paymentRes, transactionUniqueID: transactionUniqueID }
    let res = await easeBuzzPaymentStatus(paymentRes);
    if (res?.success) {
      window.location.href = res?.data
    }
    else {
      // console.log("res?.data",res?.response?.data?.data?.[0]?.msg)
      toast.error(messageError || res?.response?.data?.data?.[0]?.msg);
    }
  };
  const handleSubscription = (userDetails,subscriptionItem) => {
    // console.log("#######################", userDetails, subscriptionItem)
    fetchAccountProfile()
    setValue(1)
    if (JSON.parse(localStorage.getItem('countryId')) == "611e04284ac17121fd8b1a54")
      // movePaymentWithPayU(userDetails, subscriptionItem)
       handlerEaseBuzzForm(subscriptionItem,userDetails)
    else{
      movePayment(userDetails, subscriptionItem)
    }
      
  }
  const onClickBuySubscription = (item) => {
    // console.log("onClickBuySubscription", item)
    let selectedPack = packs.filter((e) => e._id === item)
    let userProfileFromLocal = JSON?.parse(localStorage?.getItem("profile"))
    if(!userProfileFromLocal?.email || !userProfileFromLocal?.isEmailVerified) {
      setSubscriptionItem(selectedPack)
      setIsSubscriptionPopup(true);
      setIsSubscription(false);
    }
    else {
      setValue(1)
      if (JSON.parse(localStorage.getItem('countryId')) == "611e04284ac17121fd8b1a54")
        // movePaymentWithPayU(userProfileFromLocal, subscriptionItem)
      handlerEaseBuzzForm(subscriptionItem, userProfileFromLocal)
      else{
        movePayment(userProfileFromLocal, subscriptionItem)
      }
    }
  }


  const onClickRenewSubscription = (item) => {
    // console.log("onClickRenewSubscription", item)
    let selectedPack = packs.filter((e) => e._id === item)
    let userProfileFromLocal = JSON?.parse(localStorage?.getItem("profile"))
    if(!userProfileFromLocal?.email || !userProfileFromLocal?.isEmailVerified) {
      setSubscriptionItem(selectedPack)
      setIsSubscriptionPopup(true);
      setIsSubscription(false);
    }
    else {
      setValue(1)
      if (JSON.parse(localStorage.getItem('countryId')) == "611e04284ac17121fd8b1a54")
        movePaymentWithPayU(userProfileFromLocal, subscriptionItem)
      else{
        movePayment(userProfileFromLocal, subscriptionItem)
      }
    }
  }

  const redirectHandler = (item) => {
    // navigate(`/${item}`);
    switch (item) {
      case "home":
        navigate(`/home`);
        break;
      case "leaderboard":
        navigate(`/more/leaderboard`);
        break;
      case "crm":
        navigate(`/more/customer-care`);
        break;
      case "profile":
        navigate(`/profile`);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const scrollToElement = () => {
        const elementId = window.location.hash.substring(1);
        if (elementId) {
            const element = document.getElementById(elementId);
            if (element) {
                // Smooth scroll to the element
                element.scrollIntoView({ behavior: "smooth" });
            }
        }
    };

    // Delay execution to ensure DOM is fully loaded
    setTimeout(scrollToElement, 500); // Adjust time if necessary
  }, []);

  const redirectToTabButton = () => {
    const scrollToElement = () => {
      const elementId = "subscription-duration-buttons-tabs";
      if (elementId) {
          const element = document.getElementById(elementId);
          if (element) {
              // Smooth scroll to the element
              element.scrollIntoView({ behavior: "smooth" });
          }
      }
    };

    // Delay execution to ensure DOM is fully loaded
    setTimeout(scrollToElement, 500); // Adjust time if necessary
  }

if( isLoding) return <div className="d-flex justify-content-between w-100 h-100 no-record-found-center"><ListLoader /></div> 
return (
  
  <BaseHome title={'subscription pack'}>
   
    <PremiumTextLogo />
      {userSubscriptionDetails && userSubscriptionDetails?.isRenewRequired && userSubscriptionDetails?.subscription?.isPremium && <RenewBox userSubscriptionDetails={userSubscriptionDetails} onClickRenewSubscription={() => redirectToTabButton()} />}
      {userSubscriptionDetails?.savedCurrency && userSubscriptionDetails?.subscription?.isPremium &&
        userSubscriptionDetails?.savedCurrency.map((currency) => {
          {/* console.log(userSubscriptionDetails,"userSubscriptionDetails") */}
          
          return (
            currency?.totalSavedAmount > 0 ?
              <div className="subscription-renew-coins mt-3">
                <div className="subscription-renew-coin-flex">
                  <div className="coin-icon" style={{width:"40.025px"}}>
                    <img className="mt-1 ml-1" src={getsavedCurrencyImg(currency?.currencyDetails?.img?.default)} alt="coin icon" />
                  </div>
                  <div className="coin-text">{currency?.currencyDetails?.name || "Coins"} {`you saved`}</div>
                </div>
                <div className="coin-count">{currency?.totalSavedAmount||0}</div>
              </div>
              :
              <></>
          )
        })

      }
    <div className="subscription-pack-list mt-3">
      <div className="subscription-pack-inner-wrap">
        <div className="subscription-pack-list-heading d-flex justify-content-center">benefits</div>
        <div className="subscriptionpack-info-list">
          <div className="subscriptionpack-info">
            {benefits && benefits.length > 0 &&
              benefits.map((e) => {
                return <div className="subscriptionpack-info-item">
                  <img src={getBenefitsImg(e.img.default)} alt="premium support" className="info-icon" />
                  <div className="info-text d-flex justify-content-between w-100">
                  <div>
                      <h3 className="info-title  "><span>{e.title}</span></h3>
                      <p className="info-description">{e.description}</p>

                  </div>
                  <div>
                     {userSubscriptionDetails?.subscription?.isPremium && e?.redirectionScreenLink ? (
                        <span

                          className="icon"
                          style={{ color: "#c5a260", cursor: 'pointer' }}
                          onClick={() =>
                            redirectHandler(e?.redirectionScreenLink)
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18.493"
                            height="13.154"
                            viewBox="0 0 21.493 18.154"
                          >
                            <g
                              id="ico"
                              transform="translate(21.493 18.151) rotate(-180)"
                            >
                              <path
                                id="union"
                                d="M8.389,17.858l-7.9-7.9A1,1,0,0,1,0,9.1V9.085a1,1,0,0,1,.147-.523A1,1,0,0,1,.3,8.36l.011-.011a1.01,1.01,0,0,1,.1-.091L8.389.29A1,1,0,0,1,9.8.29L9.814.3a1,1,0,0,1,0,1.415L3.442,8.086H20.493a1,1,0,0,1,1,1V9.1a1,1,0,0,1-1,1H3.48l6.334,6.333a1,1,0,0,1,0,1.415l-.011.01a1,1,0,0,1-1.414,0Z"
                                transform="translate(0 0)"
                                fill="currentColor"
                              />
                            </g>
                          </svg>
                        </span>
                      ) : (
                        <></>
                      )}
                  </div>
                    
                  </div>
                </div>
              })
            }
          </div>
        </div>
      </div>
    </div>

      {(!userSubscriptionDetails?.subscription?.isPremium) || (userSubscriptionDetails && userSubscriptionDetails?.isRenewRequired && userSubscriptionDetails?.subscription?.isPremium) ? <>
        <Tabs
          key={selectedTab}
          value={selectedTab}
          onChange={handleChange}
          className="subscription-duration-buttons-tabs"
          id="subscription-duration-buttons-tabs"
          TabIndicatorProps={{ style: { display: 'none' } }} // Hide default indicator
        >
          {tabs.map((tab) => {
            return <Tab
              key={tab.value}
              label={tab.label}
              value={tab.value}
              className={`subscription-duration-buttons-tab ${(selectedTab?.toString().trim() === tab.value.toString().trim()) ? 'active' : ''}`}
              style={{ width: `${100 / tabs.length}%`,   textTransform: 'lowercase' }} // Dynamic width based on number of tabs
              
            />
          })}
        </Tabs>
        <div className="my-4">
          <Button text={`buy for ${tabs.find(tab => tab.value === selectedTab)?.price}`} onClick={() => { onClickBuySubscription(selectedTab) }} />
        </div>
      </> : <></>
   }
 


    {isSubscriptionPopup && (
      <SubscriptionPopup
        isOpen={isSubscriptionPopup}
        title={subscriptionItem.packName}
        onClose={() => setIsSubscriptionPopup(false)}
        subscriptionItem={subscriptionItem}
        handleSubscription={handleSubscription}
        isSubscription={isSubscription}
        setIsSubscription={setIsSubscription}
        setEmailIdForPayment={setEmailIdForPayment}
      />
    )}
    {
      showPayuForm && <PayUForm showPayuForm={showPayuForm} setShowPayuForm={setShowPayuForm} payload={payUData} isSubscription={true} symbol={symbol} />
    }



  </BaseHome>
);
};

export default Subscription;
